import { cn } from "@roman/shared/utils";
import type React from "react";

interface YesNoCardProps {
  id: string;
  label: string;
  probability: number;
  onClick?: (id: string) => void;
  outlined?: boolean;
  light?: boolean;
  onlyProbability?: boolean;
  className?: string;
  isShowProbability?: boolean;
  isFixedYesNo?: boolean;
  isYesChoice?: boolean;
}

export const YesNoCard: React.FC<YesNoCardProps> = ({
  id,
  label,
  probability,
  onClick = () => {},
  outlined = false,
  light = false,
  onlyProbability = false,
  className = "",
  isShowProbability = true,
  isFixedYesNo = false,
  isYesChoice = false,
}) => {
  const yesBase = "w-full rounded-md py-1.5 font-bold flex flex-col items-center justify-center";
  const noBase = yesBase;

  const yesOutlined = "border-2 border-[#00AFCE]";
  const yesLight = "bg-[#00AFCE]/10 text-[#00AFCE]";
  const yesFilled = "text-white bg-[#00AFCE]";

  const noOutlined = "border-2 border-[#FF7FD2]";
  const noLight = "bg-[#FF7FD2]/10 text-[#FF7FD2]";
  const noFilled = "text-white bg-[#FF7FD2]";
  const percentage =
    probability * 100 >= 1 ? (Math.round(probability * 100) === 100 ? "99" : Math.round(probability * 100)) : "<1";

  const style = isYesChoice
    ? cn(yesBase, outlined && yesOutlined, light && yesLight, !outlined && !light && yesFilled)
    : cn(noBase, outlined && noOutlined, light && noLight, !outlined && !light && noFilled);

  if (isFixedYesNo) {
    return (
      <button type="button" className={cn("h-[50px]", style, className)} onClick={() => onClick(id)}>
        <span className="text-white text-center font-roboto not-italic font-bold leading-none">{label}</span>
        {isShowProbability && (
          <span className="text-white font-roboto not-italic font-medium leading-none">{percentage}%</span>
        )}
      </button>
    );
  }

  return (
    <button type="button" className={cn("min-h-[44px]", style, className)} onClick={() => onClick(id)}>
      {onlyProbability ? (
        <span className="text-[17.2px] leading-tight">
          {label} {percentage}%
        </span>
      ) : (
        <>
          <span className="text-base leading-tight">{label}</span>
          {isShowProbability && <span className="text-base font-bold leading-tight">{percentage}%</span>}
        </>
      )}
    </button>
  );
};
